import { render, staticRenderFns } from "./MyPageDeposit.vue?vue&type=template&id=66ea6e29&scoped=true"
import script from "./MyPageDeposit.vue?vue&type=script&lang=js"
export * from "./MyPageDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea6e29",
  null
  
)

export default component.exports